export default function () {
  const list = document.querySelector('[data-menu-list]');
  const media = document.querySelectorAll('[data-menu-media]');
  const activeMediaClass = 'menu__media-item--show';
  const mediaQuery = window.matchMedia('(min-width: 1024px)');

  const toggleMedia = (target) => {
    const type = target.dataset.menuLink;
    media.forEach((item) => {
      item.classList.remove(activeMediaClass);
      if (type === item.dataset.menuMedia) {
        item.classList.add(activeMediaClass);
      }
    });
  };

  if (mediaQuery.matches) {
    list?.addEventListener('mouseover', (event) => {
      const { target } = event;
      if (target.hasAttribute('data-menu-link')) {
        toggleMedia(target);
      }
    });
  }
}
